/* Furniversal site behaviour — Shopify build (generated by shopify/build.mjs) */
/* =========================================================
   FURNIVERSAL, site behaviour
   ========================================================= */
(function () {
  "use strict";

  var WA_NUMBER = "919148236891";   // fallback if content.js hasn't loaded
  var PRODUCTS = window.FURNIVERSAL_PRODUCTS || [];

  /* Website copy managed from the admin panel (assets/js/content.js).
     `cget` falls back to the value passed in whenever content isn't there,
     so every default below is also the offline fallback. */
  function cget(path, fallback) {
    return (window.FV && window.FV.get) ? window.FV.get(path, fallback) : fallback;
  }
  function waNumber() { return String(cget("global.whatsapp.number", "")).replace(/\D/g, "") || WA_NUMBER; }
  var IMG_BASE = "assets/img/products/";
  var VID_BASE = "assets/video/products/";

  function esc(s) {
    return String(s === null || s === undefined ? "" : s)
      .replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
  }

  /* ---- Media URL resolvers ----
     Product media may be stored as a bare filename ("01.jpg", legacy static
     data) or as a full path/URL ("assets/img/products/slug/01.jpg" or an
     absolute URL, data coming from the admin/API). These normalise both. */
  function isAbsPath(s) { return /^(https?:)?\/\//.test(s) || s.charAt(0) === "/" || s.indexOf("assets/") === 0; }
  function imgURL(p, entry) {
    if (!entry) return "";
    return window.FV_URL(isAbsPath(entry) ? entry : IMG_BASE + p.slug + "/" + entry);
  }
  function vidSrc(p, entry) {
    var f = (entry && entry.src) ? entry.src : entry;
    if (!f) return "";
    return window.FV_URL(isAbsPath(f) ? f : VID_BASE + p.slug + "/" + f);
  }
  function vidPoster(p, entry) {
    if (entry && entry.poster) {
      return window.FV_URL(isAbsPath(entry.poster) ? entry.poster : VID_BASE + p.slug + "/" + entry.poster);
    }
    return vidSrc(p, entry).replace(/\.mp4$/i, ".jpg");
  }

  /* ---- Category helpers ----
     Products may carry multiple categories (`categories: [...]`) or a legacy
     single `category` string. These tolerate both. */
  var CAT_ORDER = [];
  function prodCats(p) {
    if (p.categories && p.categories.length) return p.categories;
    return p.category ? [p.category] : [];
  }
  function primaryCat(p) {
    var c = prodCats(p);
    return c.length ? c[0] : "Uncategorised";
  }
  function inCat(p, cat) { return prodCats(p).indexOf(cat) > -1; }

  /* ---- Commercial helpers ---- */
  // 180000 -> "₹1,80,000" (Indian digit grouping)
  function formatINR(n) {
    n = Math.round(Number(n) || 0);
    if (!n) return "";
    var s = String(n), last3 = s.slice(-3), rest = s.slice(0, -3);
    if (rest) last3 = "," + last3;
    return "₹" + rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + last3;
  }
  function priceLabel(p) { return p.price ? formatINR(p.price) : ""; }
  // "leather" | "fabric" | "mixed", from the material wording
  function materialType(p) {
    var m = String(p.material || "").toLowerCase();
    var leather = m.indexOf("leather") > -1;
    var fabric = /fabric|bouclé|boucle|linen|velvet|chenille|cotton/.test(m);
    if (leather && fabric) return "mixed";
    return leather ? "leather" : "fabric";
  }
  function paletteFor(kind) {
    var list = cget("global.swatches." + kind, []);
    return Array.isArray(list) ? list.filter(function (c) { return c && (c.hex || c.name); }) : [];
  }
  function ownColours(p) {
    var c = Array.isArray(p.colours) ? p.colours.filter(function (x) { return x && (x.hex || x.name); }) : [];
    if (!c.length && p.colour) c = [{ name: p.colour, hex: "" }];
    return c;
  }
  function swatchDot(c, cls) {
    var hex = c.hex || "#d8cfbf";
    return '<span class="swatch' + (cls ? " " + cls : "") + '" style="background:' + esc(hex) + '" title="' + esc(c.name || "") + '" data-name="' + esc(c.name || "") + '"></span>';
  }

  /* ---- WhatsApp link helpers ---- */
  function waLink(message) {
    return "https://wa.me/" + waNumber() + "?text=" + encodeURIComponent(message);
  }
  function productEnquiry(p) {
    return waLink(
      "Hi Furniversal, I'm interested in the " + p.name +
      " (" + primaryCat(p) + "). Please share the price, fabric/leather options and delivery time."
    );
  }

  var WA_ICON =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17.5 14.4c-.3-.2-1.7-.8-2-.9-.3-.1-.5-.2-.6.2-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-1.7-.8-2.8-1.5-3.9-3.4-.3-.5.3-.5.8-1.5.1-.2 0-.4 0-.5 0-.2-.6-1.6-.9-2.2-.2-.5-.4-.5-.6-.5h-.5c-.2 0-.5.1-.7.3-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.1 4.9 4.3 1.8.8 2.5.8 3.4.7.6 0 1.7-.7 2-1.4.2-.6.2-1.2.2-1.4-.1-.1-.3-.2-.5-.3z M12 2a10 10 0 0 0-8.5 15.2L2 22l4.9-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-2.9.8.8-2.8-.2-.3A8.2 8.2 0 1 1 12 20.2z"/></svg>';
  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  /* =========================================================
     1. HEADER scroll + mobile nav
     ========================================================= */
  function initHeader() {
    var header = document.querySelector(".site-header");
    if (!header) return;
    var toggle = header.querySelector(".nav-toggle");
    var nav = header.querySelector(".nav");

    function onScroll() {
      if (window.scrollY > 40) header.classList.add("scrolled");
      else header.classList.remove("scrolled");
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    if (toggle && nav) {
      toggle.addEventListener("click", function () { nav.classList.toggle("open"); });
      nav.addEventListener("click", function (e) {
        if (e.target.closest("a")) nav.classList.remove("open");
      });
    }
  }

  /* =========================================================
     1b. Hero slideshow (crossfade), kept for image heroes
     ========================================================= */
  function initHeroSlider() {
    var wrap = document.getElementById("hero-slides");
    if (!wrap) return;
    var slides = Array.prototype.slice.call(wrap.querySelectorAll(".hero-slide"));
    if (slides.length < 2) return;

    var dotsWrap = document.getElementById("hero-dots");
    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", "Show slide " + (i + 1));
        if (i === 0) b.className = "active";
        b.addEventListener("click", function () { go(i, true); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    var current = 0, INTERVAL = 5500, timer = null;
    function go(next, manual) {
      if (next === current) return;
      slides[current].classList.remove("active");
      slides[next].classList.add("active");
      var img = slides[next].querySelector("img");
      if (img) { img.style.animation = "none"; void img.offsetWidth; img.style.animation = ""; }
      if (dots.length) { dots[current].classList.remove("active"); dots[next].classList.add("active"); }
      current = next;
      if (manual) restart();
    }
    function advance() { go((current + 1) % slides.length); }
    function start() { timer = window.setInterval(advance, INTERVAL); }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }
    document.addEventListener("visibilitychange", function () { if (document.hidden) stop(); else restart(); });
    start();
  }

  /* =========================================================
     2. Reveal on scroll
     ========================================================= */
  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll("[data-reveal]:not(.in)"));
    if (!els.length) return;

    if (!("IntersectionObserver" in window)) {
      els.forEach(function (e) { e.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.08, rootMargin: "0px 0px -40px 0px" });

    els.forEach(function (e) {
      var r = e.getBoundingClientRect();
      if (r.top < (window.innerHeight || document.documentElement.clientHeight)) e.classList.add("in");
      else io.observe(e);
    });
    // Safety net: never leave content permanently hidden if IO misbehaves
    setTimeout(function () { els.forEach(function (e) { e.classList.add("in"); }); }, 1600);
  }

  /* =========================================================
     3. WhatsApp floating widget
     ========================================================= */
  function initWidget() {
    var wrap = document.getElementById("wapp-widget");
    if (!wrap) return;
    var toggle = wrap.querySelector("#wapp-toggle");
    var modal = wrap.querySelector("#wapp-modal");
    var closeBtn = wrap.querySelector("#wapp-close");
    var cta = wrap.querySelector("#wapp-cta");
    if (cta) cta.href = waLink("Hi Furniversal, I would like a free design consultation.");

    if (toggle) toggle.addEventListener("click", function () { modal.classList.toggle("active"); });
    if (closeBtn) closeBtn.addEventListener("click", function () { modal.classList.remove("active"); });
    document.addEventListener("click", function (e) {
      if (modal && modal.classList.contains("active") && !wrap.contains(e.target)) modal.classList.remove("active");
    });
  }

  /* =========================================================
     4. Product card (home + shop + product rows)
     Picture first: photo, name, one line, colour dots, starting price.
     ========================================================= */
  function cardHTML(p, delay) {
    var href = window.FV_URL("product.html?p=" + p.slug);
    var img1 = imgURL(p, p.images[0]);
    var img2 = p.images.length > 1 ? imgURL(p, p.images[1]) : "";
    var own = ownColours(p);
    var extra = paletteFor(materialType(p) === "leather" ? "leather" : "fabric").length;
    var dots = own.slice(0, 4).map(function (c) { return swatchDot(c); }).join("");
    if (extra) dots += '<span class="more">+' + extra + " " + cget("shop.card.moreColours", "colours") + "</span>";
    var price = priceLabel(p);
    var meta = [p.material, p.seating].filter(Boolean).join(" · ");
    return (
      '<article class="product-card" data-reveal data-reveal-delay="' + (delay || 0) + '" data-category="' + esc(prodCats(p).join("|")) + '">' +
        '<a class="product-media" href="' + href + '" aria-label="' + esc(p.name) + '">' +
          '<span class="product-tag">' + esc(primaryCat(p)) + "</span>" +
          (img2 ? '<img class="alt" src="' + esc(img2) + '" alt="" loading="lazy">' : "") +
          '<img class="main' + (img2 ? " has-alt" : "") + '" src="' + esc(img1) + '" alt="' + esc(p.name + ", " + p.tagline) + '" loading="lazy">' +
        "</a>" +
        '<a class="icon-wa-btn" target="_blank" rel="noopener" href="' + productEnquiry(p) + '" aria-label="Enquire about ' + esc(p.name) + ' on WhatsApp">' + WA_ICON + "</a>" +
        '<div class="product-body">' +
          '<h3><a href="' + href + '">' + esc(p.name) + "</a></h3>" +
          '<p class="p-meta">' + esc(meta) + "</p>" +
          '<div class="swatches">' + dots + "</div>" +
          (price
            ? '<div class="p-price"><small>' + esc(cget("shop.card.fromLabel", "From")) + "</small>" + price + "</div>"
            : '<div class="p-price"><small>' + esc(cget("product.detail.priceTag", "Price on enquiry")) + "</small></div>") +
        "</div>" +
      "</article>"
    );
  }

  /* ---- Video helpers ---- */
  function productHasVideo(p) { return p && p.videos && p.videos.length; }

  // A muted, looping, controls-free reel that plays only while on screen
  // (see initVideoAutoplay). Each clip uses its own frame as the poster.
  function videoHTML(p, file, extraClass) {
    var base = vidSrc(p, file);
    var poster = vidPoster(p, file);
    return (
      '<video class="fv-video' + (extraClass ? " " + extraClass : "") + '" muted loop playsinline ' +
        'preload="metadata" disablepictureinpicture poster="' + esc(poster) + '">' +
        '<source src="' + esc(base) + '" type="video/mp4">' +
        "Your browser doesn't support embedded video." +
      "</video>"
    );
  }

  // Play reels when they scroll into view, pause when they leave, keeps the
  // page light even with many autoplaying clips.
  function initVideoAutoplay() {
    var vids = Array.prototype.slice.call(document.querySelectorAll(".fv-video:not([data-autoplay])"));
    if (!vids.length) return;
    vids.forEach(function (v) { v.setAttribute("data-autoplay", "1"); v.muted = true; });
    function tryPlay(v) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    if (!("IntersectionObserver" in window)) { vids.forEach(tryPlay); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) tryPlay(en.target); else en.target.pause(); });
    }, { threshold: 0.4 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---- Home: furniture in motion ----
     Clips carry no product name (client brief); the whole card is a link to
     the product page. ---- */
  function initHomeVideos() {
    var grid = document.getElementById("home-videos");
    if (!grid) return;
    var html = "", i = 0;
    var max = parseInt(cget("home.motion.max", 12), 10) || 12;
    PRODUCTS.forEach(function (p) {
      if (!productHasVideo(p)) return;
      p.videos.forEach(function (file) {
        if (i >= max) return;
        html +=
          '<a class="video-card" href="' + window.FV_URL("product.html?p=" + p.slug) + '" aria-label="' + esc(p.name) + '" data-reveal data-reveal-delay="' + (i % 3) + '">' +
            videoHTML(p, file) +
            '<span class="video-go">' + esc(cget("home.motion.linkLabel", "View this piece")) + ARROW + "</span>" +
          "</a>";
        i++;
      });
    });
    grid.innerHTML = html;
    initReveal();
    initVideoAutoplay();
    initReelCarousel(grid);
  }

  /* A draggable carousel for the reels that glides forward on its own.
     The strip is cloned once so the glide loops seamlessly; it pauses while
     the pointer is over it (or a clip has keyboard focus) and after the
     visitor scrolls, drags or taps it, then continues. Arrows page through
     it and dots mark the pages. */
  function initReelCarousel(track) {
    var wrap = track.closest(".reel-carousel");
    if (!wrap || track.dataset.carousel) return;
    track.dataset.carousel = "1";
    var prev = wrap.querySelector(".reel-nav.prev");
    var next = wrap.querySelector(".reel-nav.next");
    var dotsWrap = wrap.querySelector(".reel-dots");
    var dots = [];

    /* glide speed in pixels per second (0 = no auto-scroll); honours the
       visitor's reduced-motion preference */
    var SPEED = parseFloat(cget("home.motion.speed", 30));
    if (isNaN(SPEED) || SPEED < 0) SPEED = 30;
    var RESUME = parseInt(cget("home.motion.autoMs", 6000), 10);
    if (isNaN(RESUME) || RESUME < 0) RESUME = 6000;
    var reduceMotion = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    var glide = SPEED > 0 && !reduceMotion && track.children.length > 1;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
    var loopWidth = 0;

    function measureLoop() { loopWidth = glide ? (track.scrollWidth + gap) / 2 : 0; }
    if (glide) {
      loopWidth = track.scrollWidth + gap;
      Array.prototype.slice.call(track.children).forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.classList.add("is-clone", "in");
        clone.removeAttribute("data-reveal");
        clone.setAttribute("aria-hidden", "true");
        clone.setAttribute("tabindex", "-1");
        clone.querySelectorAll("video").forEach(function (v) { v.removeAttribute("data-autoplay"); });
        track.appendChild(clone);
      });
      track.style.scrollSnapType = "none";      // snapping fights a per-frame glide
      track.style.scrollBehavior = "auto";      // arrows still ask for smooth scrolling explicitly
      initVideoAutoplay();
    }

    function pageWidth() { return Math.max(1, track.clientWidth); }
    function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }
    function span() { return loopWidth || track.scrollWidth; }
    function pageCount() { return Math.max(1, Math.ceil(span() / pageWidth())); }
    function currentPage() {
      var left = loopWidth ? track.scrollLeft % loopWidth : track.scrollLeft;
      return Math.min(pageCount() - 1, Math.round(left / pageWidth()));
    }
    // keep the scroll position inside the first copy of the strip (instant, invisible)
    function normalize() {
      if (loopWidth && track.scrollLeft >= loopWidth) track.scrollLeft = track.scrollLeft - loopWidth;
    }

    function buildDots() {
      measureLoop();
      if (!dotsWrap) return;
      dotsWrap.innerHTML = "";
      dots = [];
      var n = pageCount();
      if (n < 2) return;
      for (var i = 0; i < n; i++) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", "Show reels page " + (i + 1));
        (function (idx) { b.addEventListener("click", function () { goTo(idx); userTouched(); }); })(i);
        dotsWrap.appendChild(b);
        dots.push(b);
      }
      sync();
    }
    function sync() {
      var atStart = !loopWidth && track.scrollLeft <= 2, atEnd = !loopWidth && track.scrollLeft >= maxScroll() - 2;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      var cur = currentPage();
      dots.forEach(function (d, i) { d.classList.toggle("active", i === cur); });
    }
    function goTo(page) {
      var n = pageCount();
      page = ((page % n) + n) % n;
      normalize();
      track.scrollTo({ left: Math.min(maxScroll(), page * pageWidth()), behavior: "smooth" });
    }
    function step(dir) {
      normalize();
      var target = track.scrollLeft + dir * pageWidth() * 0.85;
      if (loopWidth) {
        if (target < 0) { track.scrollLeft = track.scrollLeft + loopWidth; target += loopWidth; }
      } else {
        if (dir > 0 && track.scrollLeft >= maxScroll() - 2) target = 0;          // wrap around
        if (dir < 0 && track.scrollLeft <= 2) target = maxScroll();
      }
      track.scrollTo({ left: Math.max(0, Math.min(maxScroll(), target)), behavior: "smooth" });
    }
    if (prev) prev.addEventListener("click", function () { step(-1); userTouched(); });
    if (next) next.addEventListener("click", function () { step(1); userTouched(); });

    var raf = null;
    track.addEventListener("scroll", function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; sync(); });
    }, { passive: true });
    window.addEventListener("resize", buildDots);

    /* mouse drag to scroll (touch already scrolls natively) */
    var down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse") return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener("pointermove", function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) { moved = true; track.classList.add("dragging"); }
      if (moved) track.scrollLeft = startLeft - dx;
    });
    function endDrag(e) {
      if (!down) return;
      down = false;
      if (moved) {
        track.classList.remove("dragging");
        userTouched();
        // snap to the nearest card
        var card = track.querySelector(".video-card");
        var w = card ? card.getBoundingClientRect().width + gap : pageWidth();
        track.scrollTo({ left: Math.round(track.scrollLeft / w) * w, behavior: "smooth" });
      }
    }
    track.addEventListener("pointerup", endDrag);
    track.addEventListener("pointercancel", endDrag);
    track.addEventListener("click", function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

    /* the glide: a few pixels every frame while the carousel is on screen,
       untouched and not under the pointer */
    var paused = false, resumeAt = 0, visible = false, pos = 0, lastSet = -1, lastTs = 0;
    function userTouched() { resumeAt = Date.now() + RESUME; }
    wrap.addEventListener("mouseenter", function () { paused = true; });
    wrap.addEventListener("mouseleave", function () { paused = false; });
    wrap.addEventListener("focusin", function () { paused = true; });
    wrap.addEventListener("focusout", function () { paused = false; });
    track.addEventListener("touchstart", userTouched, { passive: true });
    track.addEventListener("wheel", userTouched, { passive: true });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.3 }).observe(wrap);
    } else visible = true;

    function frame(ts) {
      requestAnimationFrame(frame);
      var dt = lastTs ? Math.min(64, ts - lastTs) : 0;
      lastTs = ts;
      if (!visible || paused || down || document.hidden || Date.now() < resumeAt || !loopWidth) { lastSet = -1; return; }
      if (lastSet < 0 || Math.abs(track.scrollLeft - lastSet) > 2) pos = track.scrollLeft;   // pick up where the visitor left it
      pos += SPEED * dt / 1000;
      if (pos >= loopWidth) pos -= loopWidth;
      lastSet = pos;
      track.scrollLeft = pos;
    }
    if (glide) requestAnimationFrame(frame);

    buildDots();
    // media may still be sizing; measure again once the posters have loaded
    setTimeout(buildDots, 800);
  }

  /* ---- Home: featured products ---- */
  function initHomeProducts() {
    var grid = document.getElementById("home-products");
    if (!grid) return;
    var featured = cget("home.featured.slugs", ["kendra", "gemma", "lola", "mystica", "valencia", "fritz", "cloudoo", "quinn"]);
    if (!Array.isArray(featured) || !featured.length) featured = PRODUCTS.slice(0, 8).map(function (p) { return p.slug; });
    var html = featured.map(function (slug, i) {
      var p = PRODUCTS.find(function (x) { return x.slug === slug; });
      return p ? cardHTML(p, i % 4) : "";
    }).join("");
    grid.innerHTML = html;
    initReveal();
  }

  /* =========================================================
     5. Shop page, grid + filters (category + material)
     ========================================================= */
  function initShop() {
    var grid = document.getElementById("shop-grid");
    if (!grid) return;
    var filterWrap = document.getElementById("shop-filters");
    var subWrap = document.getElementById("shop-subfilters");
    var countEl = document.getElementById("result-count");

    var used = {};
    PRODUCTS.forEach(function (p) { prodCats(p).forEach(function (c) { used[c] = true; }); });
    var ordered = (CAT_ORDER || []).filter(function (c) { return used[c]; });
    Object.keys(used).forEach(function (c) { if (ordered.indexOf(c) === -1) ordered.push(c); });
    var cats = ["All"].concat(ordered);

    var params = new URLSearchParams(window.location.search);
    var active = params.get("cat") && cats.indexOf(params.get("cat")) > -1 ? params.get("cat") : "All";
    if (active === "All" && window.FV_SHOPIFY && window.FV_SHOPIFY.collectionCategory && cats.indexOf(window.FV_SHOPIFY.collectionCategory) > -1) active = window.FV_SHOPIFY.collectionCategory;
    var mat = params.get("material") || "all";
    var MATS = [["all", cget("shop.filters.allMaterials", "All materials")], ["fabric", cget("shop.filters.fabric", "Fabric")], ["leather", cget("shop.filters.leather", "Genuine leather")]];

    function syncURL() {
      var q = [];
      if (active !== "All") q.push("cat=" + encodeURIComponent(active));
      if (mat !== "all") q.push("material=" + mat);
      history.replaceState(null, "", window.location.pathname + (q.length ? "?" + q.join("&") : ""));
    }

    if (filterWrap) {
      filterWrap.innerHTML = cats.map(function (c) {
        return '<button class="filter-btn' + (c === active ? " active" : "") + '" data-cat="' + esc(c) + '">' + esc(c) + "</button>";
      }).join("");
      filterWrap.addEventListener("click", function (e) {
        var btn = e.target.closest(".filter-btn");
        if (!btn) return;
        active = btn.dataset.cat;
        filterWrap.querySelectorAll(".filter-btn").forEach(function (b) { b.classList.toggle("active", b === btn); });
        render(); syncURL();
      });
    }
    if (subWrap) {
      subWrap.innerHTML = MATS.map(function (m) {
        return '<button class="filter-btn' + (m[0] === mat ? " active" : "") + '" data-mat="' + m[0] + '">' + esc(m[1]) + "</button>";
      }).join("");
      subWrap.addEventListener("click", function (e) {
        var btn = e.target.closest(".filter-btn");
        if (!btn) return;
        mat = btn.dataset.mat;
        subWrap.querySelectorAll(".filter-btn").forEach(function (b) { b.classList.toggle("active", b === btn); });
        render(); syncURL();
      });
    }

    function render() {
      var list = active === "All" ? PRODUCTS : PRODUCTS.filter(function (p) { return inCat(p, active); });
      if (mat !== "all") list = list.filter(function (p) { var t = materialType(p); return t === mat || t === "mixed"; });
      grid.innerHTML = list.length
        ? list.map(function (p, i) { return cardHTML(p, i % 4); }).join("")
        : '<p class="shop-empty">' + esc(cget("shop.filters.empty", "No pieces match that filter yet. Message us on WhatsApp and we'll make one for you.")) + "</p>";
      if (countEl) countEl.textContent = list.length + (list.length === 1 ? " piece" : " pieces");
      initReveal();
    }
    render();
  }

  /* =========================================================
     6. Single product page
     ========================================================= */
  function dimDiagram(d) {
    if (!d || !(d.w || d.d || d.h)) return "";
    var W = d.w || 0, D = d.d || 0, H = d.h || 0;
    return (
      '<svg class="dim-diagram" viewBox="0 0 380 150" role="img" aria-label="Width ' + W + ' cm, depth ' + D + ' cm, height ' + H + ' cm">' +
        // front view
        '<rect class="body" x="30" y="28" width="196" height="30" rx="9"/>' +
        '<rect class="body" x="22" y="52" width="212" height="52" rx="8"/>' +
        '<rect class="body" x="22" y="52" width="22" height="52" rx="8"/>' +
        '<rect class="body" x="212" y="52" width="22" height="52" rx="8"/>' +
        '<rect x="34" y="104" width="6" height="9" fill="#4a4d33"/><rect x="216" y="104" width="6" height="9" fill="#4a4d33"/>' +
        '<line class="dl" x1="22" y1="128" x2="234" y2="128"/><line class="dl" x1="22" y1="123" x2="22" y2="133"/><line class="dl" x1="234" y1="123" x2="234" y2="133"/>' +
        '<text x="128" y="144" text-anchor="middle">W ' + W + " cm</text>" +
        '<line class="dl" x1="250" y1="28" x2="250" y2="113"/><line class="dl" x1="245" y1="28" x2="255" y2="28"/><line class="dl" x1="245" y1="113" x2="255" y2="113"/>' +
        '<text x="256" y="74" transform="rotate(90 256 74)" text-anchor="middle">H ' + H + " cm</text>" +
        // side view
        '<rect class="body" x="292" y="28" width="20" height="76" rx="7"/>' +
        '<rect class="body" x="292" y="62" width="70" height="42" rx="7"/>' +
        '<rect x="300" y="104" width="6" height="9" fill="#4a4d33"/><rect x="350" y="104" width="6" height="9" fill="#4a4d33"/>' +
        '<line class="dl" x1="292" y1="128" x2="362" y2="128"/><line class="dl" x1="292" y1="123" x2="292" y2="133"/><line class="dl" x1="362" y1="123" x2="362" y2="133"/>' +
        '<text x="327" y="144" text-anchor="middle">D ' + D + " cm</text>" +
      "</svg>"
    );
  }

  function materialChips(p) {
    var t = materialType(p);
    var opts = [
      ["leather-full", cget("product.detail.matLeatherFull", "Genuine leather · full leather")],
      ["leather-half", cget("product.detail.matLeatherHalf", "Genuine leather · half (body-touch)")],
      ["fabric", cget("product.detail.matFabric", "Premium fabric")]
    ];
    var on = t === "fabric" ? "fabric" : "leather-full";
    return opts.map(function (o) { return '<span class="' + (o[0] === on ? "on" : "") + '">' + esc(o[1]) + "</span>"; }).join("");
  }

  function colourGroups(p) {
    var own = ownColours(p);
    var fabric = paletteFor("fabric"), leather = paletteFor("leather");
    var html = "";
    if (own.length) {
      html += '<div class="swatch-group"><div class="sg-title"><span>' + esc(cget("product.detail.colourOwn", "As photographed")) + "</span></div>" +
        '<div class="swatches">' + own.map(function (c) { return swatchDot(c, "lg active"); }).join("") + "</div></div>";
    }
    if (fabric.length) {
      html += '<div class="swatch-group"><div class="sg-title"><span>' + esc(cget("product.detail.colourFabric", "Premium fabric colours")) + "</span><span>" + fabric.length + "</span></div>" +
        '<div class="swatches">' + fabric.map(function (c) { return swatchDot(c, "lg"); }).join("") + "</div></div>";
    }
    if (leather.length) {
      html += '<div class="swatch-group"><div class="sg-title"><span>' + esc(cget("product.detail.colourLeather", "Genuine leather colours")) + "</span><span>" + leather.length + "</span></div>" +
        '<div class="swatches">' + leather.map(function (c) { return swatchDot(c, "lg"); }).join("") + "</div></div>";
    }
    return html + '<div class="swatch-name" id="swatch-name">' + esc(own.length ? own[0].name : "") + "</div>";
  }

  function comfortScale(val) {
    var levels = ["Soft", "Medium", "Firm"];
    var v = String(val || "").toLowerCase();
    return levels.map(function (l) {
      var on = v.indexOf(l.toLowerCase()) > -1;
      return '<span class="' + (on ? "on" : "") + '">' + l + "</span>";
    }).join("");
  }

  var RECENT_KEY = "fv_recent";
  function readRecent() { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || "[]"); } catch (e) { return []; } }
  function pushRecent(slug) {
    try {
      var r = readRecent().filter(function (s) { return s !== slug; });
      r.unshift(slug);
      localStorage.setItem(RECENT_KEY, JSON.stringify(r.slice(0, 12)));
    } catch (e) {}
  }

  function initProduct() {
    var root = document.getElementById("pdp");
    if (!root) return;
    var params = new URLSearchParams(window.location.search);
    var slug = (window.FV_SHOPIFY && window.FV_SHOPIFY.productHandle) || params.get("p");
    var p = PRODUCTS.find(function (x) { return x.slug === slug; }) || (window.FV_SHOPIFY ? null : PRODUCTS[0]);
    if (!p) return;

    var prefix = cget("product.detail.namePrefix", "Furniversal");
    var fullName = (prefix ? prefix + " " : "") + p.name;
    document.title = fullName + " | " + cget("product.detail.titleSuffix", "Custom sofas & furniture, Bengaluru");
    var crumb = document.getElementById("pdp-crumb");
    if (crumb) crumb.textContent = p.name;

    /* gallery: photos + video clips share one strip of thumbnails */
    var thumbs = p.images.map(function (img, i) {
      var u = imgURL(p, img);
      return '<button class="' + (i === 0 ? "active" : "") + '" data-img="' + esc(u) + '">' +
             '<img src="' + esc(u) + '" alt="' + esc(p.name) + ' view ' + (i + 1) + '" loading="lazy"></button>';
    }).join("");
    if (productHasVideo(p)) {
      thumbs += p.videos.map(function (v, i) {
        return '<button class="is-video" data-video="' + esc(vidSrc(p, v)) + '" data-poster="' + esc(vidPoster(p, v)) + '" aria-label="Play video ' + (i + 1) + '">' +
               '<img src="' + esc(vidPoster(p, v)) + '" alt="" loading="lazy"></button>';
      }).join("");
    }

    var price = priceLabel(p);
    var perks = String(cget("product.detail.perks", "No Cost EMI available\n7-day no-questions-asked return\nFree delivery & installation")).split("\n").filter(Boolean);
    var configs = Array.isArray(p.configs) && p.configs.length ? p.configs : (p.seating ? [p.seating] : []);
    var dims = p.dimensions || {};
    var dimText = (dims.w || dims.d || dims.h) ? "W " + dims.w + " × D " + dims.d + " × H " + dims.h + " cm" : cget("product.detail.sizeCustom", "Made to your size");
    var features = (p.features || []).map(function (f) { return "<li>" + esc(f) + "</li>"; }).join("");
    var trust = [
      ["truck", cget("product.detail.trust1", "Free delivery & free installation")],
      ["award", cget("product.detail.trust2", "50 years of manufacturing experience")],
      ["pen",   cget("product.detail.trust3", "Designed by internationally renowned designers")],
      ["chat",  '<a href="support.html">' + esc(cget("product.detail.trust4", "Exceptional customer service & support")) + "</a>"]
    ];
    var TRUST_ICONS = {
      truck: '<path d="M3 7h11v10H3zM14 10h4l3 3v4h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/>',
      award: '<circle cx="12" cy="9" r="5"/><path d="M8.5 13.5L7 21l5-2.5L17 21l-1.5-7.5"/>',
      pen:   '<path d="M4 20l4-1 10-10-3-3L5 16z"/><path d="M13 7l3 3"/>',
      chat:  '<path d="M4 5h16v11H8l-4 4z"/>'
    };

    /* fold-outs: maintenance guide, warranty, shipping & returns.
       Content is the Customer-services copy (support.care / support.warranty /
       support.policies), so it is edited once in the admin and shown here
       matched to the piece: fabric tips for fabric sofas, leather for leather,
       recliner tips only for pieces that recline. */
    function accItem(title, body) {
      return '<div class="faq-item"><button class="faq-q" type="button">' + esc(title) + '<span class="faq-icon"></span></button>' +
             '<div class="faq-a"><div class="acc-body">' + body + "</div></div></div>";
    }
    function tipList(items) {
      var arr = Array.isArray(items) ? items : String(items || "").split("\n");
      return "<ul>" + arr.map(function (x) { return String(x).trim(); }).filter(Boolean).map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + "</ul>";
    }
    var accordions = "";
    var careCards = cget("support.care.cards", []);
    if (Array.isArray(careCards) && careCards.length) {
      var mt = materialType(p);
      var reclines = inCat(p, "Recliners") || /reclin/i.test([p.tagline, p.seating].concat(p.configs || []).join(" "));
      var picked = careCards.filter(function (c) {
        var t = String(c.title || "").toLowerCase();
        if (/leather/.test(t)) return mt !== "fabric";
        if (/fabric/.test(t)) return mt !== "leather";
        if (/reclin/.test(t)) return reclines;
        return true;
      });
      if (!picked.length) picked = careCards;
      accordions += accItem(cget("product.detail.guideCare", "Maintenance guide"),
        picked.map(function (c) { return "<h5>" + esc(c.title) + "</h5>" + tipList(c.items); }).join("") +
        '<a href="support.html#care">' + esc(cget("product.detail.guideCareLink", "Read the full care guide")) + "</a>");
    }
    var warrantyCards = cget("support.warranty.cards", []);
    if (Array.isArray(warrantyCards) && warrantyCards.length) {
      accordions += accItem(cget("product.detail.guideWarranty", "10-year warranty"),
        warrantyCards.slice(0, 2).map(function (c) { return "<h5>" + esc(c.title) + "</h5>" + tipList(c.items); }).join("") +
        '<a href="support.html#warranty">' + esc(cget("product.detail.guideWarrantyLink", "Full warranty details")) + "</a>");
    }
    var policies = cget("support.policies.blocks", []);
    if (Array.isArray(policies) && policies.length) {
      var ship = policies.filter(function (b) { return /ship|return/i.test(String(b.id || "") + " " + String(b.title || "")); });
      if (ship.length) {
        accordions += accItem(cget("product.detail.guideShipping", "Shipping & returns"),
          ship.map(function (b) { return "<h5>" + esc(b.title) + "</h5><p>" + esc(String(b.body || "").split(/\n\s*\n/)[0]) + "</p>"; }).join("") +
          '<a href="support.html#' + esc(ship[0].id || "shipping") + '">' + esc(cget("product.detail.guideShippingLink", "Read the full policies")) + "</a>");
      }
    }
    if (accordions) accordions = '<div class="pdp-acc">' + accordions + "</div>";

    var videoSection = "";
    if (productHasVideo(p)) {
      var vids = p.videos.map(function (file, i) { return videoHTML(p, file, i === 0 ? "is-primary" : ""); }).join("");
      videoSection =
        '<section class="pdp-video" data-reveal>' +
          '<div class="pdp-video-head">' +
            '<span class="eyebrow">' + esc(cget("product.detail.videoEyebrow", "See it in motion")) + "</span>" +
            "<h2>" + esc(cget("product.detail.videoTitle", "In real light and detail")) + "</h2>" +
          "</div>" +
          '<div class="pdp-video-grid' + (p.videos.length === 1 ? " single" : "") + '">' + vids + "</div>" +
        "</section>";
    }

    root.innerHTML =
      '<div class="pdp-grid">' +
        '<div class="pdp-gallery" data-reveal>' +
          '<div class="gallery-main" id="gallery-main"><img id="gallery-main-img" src="' + esc(imgURL(p, p.images[0])) + '" alt="' + esc(p.name) + '"></div>' +
          '<div class="gallery-thumbs">' + thumbs + "</div>" +
        "</div>" +
        '<div class="pdp-info" data-reveal data-reveal-delay="1">' +
          prodCats(p).map(function (c) { return '<a class="cat-pill" href="' + window.FV_URL("shop.html?cat=" + encodeURIComponent(c)) + '">' + esc(c) + "</a>"; }).join(" ") +
          "<h1>" + esc(fullName) + "</h1>" +
          '<p class="lead">' + esc(p.tagline) + (p.seating ? " · " + esc(p.seating) : "") + "</p>" +
          '<div class="pdp-price v2">' +
            (price
              ? '<div class="price-from"><small>' + esc(cget("product.detail.fromLabel", "Starting from")) + "</small>" + price + "</div>"
              : '<div class="price-from"><small>' + esc(cget("product.detail.priceSub", "Made-to-order · custom sizing")) + "</small>" + esc(cget("product.detail.priceTag", "Price on enquiry")) + "</div>") +
            '<div class="price-perks">' + perks.map(function (x) { return "<span>" + esc(x) + "</span>"; }).join("") + "</div>" +
          "</div>" +
          '<p class="desc">' + esc(p.description) + "</p>" +

          '<div class="spec-block"><div class="spec-label"><span>' + esc(cget("product.detail.sizeLabel", "Size")) + "</span><strong>" + esc(dimText) + "</strong></div>" +
            '<div class="dim-wrap">' + dimDiagram(dims) +
              ((dims.w || dims.d || dims.h) ? '<ul class="dim-list"><li><span>Width</span><span>' + dims.w + ' cm</span></li><li><span>Depth</span><span>' + dims.d + ' cm</span></li><li><span>Height</span><span>' + dims.h + " cm</span></li></ul>" : "") +
            "</div>" +
            '<p class="dim-note"><svg viewBox="0 0 24 24"><path d="M3 12h18M3 12l4-4M3 12l4 4M21 12l-4-4M21 12l-4 4"/></svg>' + esc(cget("product.detail.sizeNote", "Custom sizes made to fit your room, share your wall measurement on WhatsApp.")) + "</p>" +
          "</div>" +

          '<div class="spec-block"><div class="spec-label"><span>' + esc(cget("product.detail.configLabel", "Configuration")) + "</span><strong>" + esc(configs[0] || "") + "</strong></div>" +
            '<div class="chips">' + configs.map(function (c, i) { return '<span class="' + (i === 0 ? "on" : "") + '">' + esc(c) + "</span>"; }).join("") +
              '<span class="custom">' + esc(cget("product.detail.configCustom", "+ Custom configuration")) + "</span></div>" +
            '<a class="data-sheet" target="_blank" rel="noopener" href="' + waLink("Hi Furniversal, please send me the customisation data sheet for the " + p.name + ".") + '">' +
              '<svg viewBox="0 0 24 24"><path d="M6 3h9l5 5v13H6z"/><path d="M14 3v6h6M9 13h6M9 17h6"/></svg>' + esc(cget("product.detail.dataSheet", "Request the customisation data sheet")) + "</a>" +
          "</div>" +

          '<div class="spec-block"><div class="spec-label"><span>' + esc(cget("product.detail.materialLabel", "Material")) + "</span><strong>" + esc(p.material) + "</strong></div>" +
            '<div class="chips">' + materialChips(p) + "</div>" +
          "</div>" +

          '<div class="spec-block"><div class="spec-label"><span>' + esc(cget("product.detail.colourLabel", "Colour")) + "</span><strong>" + esc(p.colour) + "</strong></div>" +
            '<div class="swatch-groups">' + colourGroups(p) + "</div>" +
          "</div>" +

          '<div class="spec-row3">' +
            '<div class="spec-block"><div class="spec-label"><span>' + esc(cget("product.detail.comfortLabel", "Comfort")) + "</span></div>" +
              '<div class="comfort-scale">' + comfortScale(p.comfort) + "</div></div>" +
            '<div class="spec-block"><div class="spec-label"><span>' + esc(cget("product.detail.deliveryLabel", "Delivery")) + "</span></div>" +
              '<div class="spec-mini">' + esc(cget("product.detail.deliveryValue", "From 30 days")) + "<small>" + esc(cget("product.detail.deliveryNote", "Subject to fabric / leather availability")) + "</small></div></div>" +
            '<div class="spec-block"><div class="spec-label"><span>' + esc(cget("product.detail.warrantyLabel", "Warranty")) + "</span></div>" +
              '<div class="spec-mini">' + esc(cget("product.detail.warrantyValue", "10 years")) + '<small><a href="support.html#warranty">' + esc(cget("product.detail.warrantyNote", "What's covered")) + "</a></small></div></div>" +
          "</div>" +

          (features ? '<div class="pdp-features" style="margin-top:26px"><h4>' + esc(cget("product.detail.featuresLabel", "Key features")) + '</h4><ul class="feature-list">' + features + "</ul></div>" : "") +
          accordions +

          '<div class="pdp-trust">' + trust.map(function (t) {
            return "<div><svg viewBox=\"0 0 24 24\">" + TRUST_ICONS[t[0]] + "</svg><span>" + t[1] + "</span></div>";
          }).join("") + "</div>" +

          '<div class="pdp-cta v2">' +
            '<a class="btn btn-wa btn-lg" id="pdp-enquire" target="_blank" rel="noopener" href="' + productEnquiry(p) + '">' + WA_ICON + " " + esc(cget("product.detail.enquireLabel", "WhatsApp this sofa")) + "</a>" +
            '<div class="pdp-cta-row">' +
              '<a class="btn btn-outline btn-lg" href="' + waLink("Hi Furniversal, I'd like to book a showroom consultation for the " + p.name + ".") + '" target="_blank" rel="noopener">' + esc(cget("product.detail.consultLabel", "Book a showroom consultation")) + "</a>" +
              '<a class="btn btn-brass btn-lg" href="#estimate">' + esc(cget("product.detail.estimateLabel", "Get your sofa estimate")) + "</a>" +
            "</div>" +
          "</div>" +
          '<div class="help-box"><p><strong>' + esc(cget("product.detail.helpTitle", "Need help? Ask a question")) + "</strong>" + esc(cget("product.detail.helpText", "A designer replies on WhatsApp, usually within minutes.")) + "</p>" +
            '<a target="_blank" rel="noopener" href="' + waLink("Hi Furniversal, I have a question about the " + p.name + ".") + '">' + WA_ICON + esc(cget("product.detail.helpCta", "Chat now")) + "</a></div>" +
        "</div>" +
      "</div>" +
      videoSection;

    /* gallery interaction: photo thumbs swap the image, video thumbs play the clip */
    var main = document.getElementById("gallery-main");
    root.querySelectorAll(".gallery-thumbs button").forEach(function (b) {
      b.addEventListener("click", function () {
        root.querySelectorAll(".gallery-thumbs button").forEach(function (x) { x.classList.remove("active"); });
        b.classList.add("active");
        if (b.dataset.video) {
          main.innerHTML = '<video controls autoplay muted playsinline poster="' + esc(b.dataset.poster) + '"><source src="' + esc(b.dataset.video) + '" type="video/mp4"></video>';
        } else {
          main.innerHTML = '<img id="gallery-main-img" src="' + esc(b.dataset.img) + '" alt="' + esc(p.name) + '">';
        }
      });
    });
    /* swatch name on hover */
    var nameEl = document.getElementById("swatch-name");
    root.querySelectorAll(".swatch-groups .swatch").forEach(function (s) {
      s.addEventListener("mouseenter", function () { if (nameEl) nameEl.textContent = s.dataset.name || ""; });
      s.addEventListener("click", function () {
        root.querySelectorAll(".swatch-groups .swatch").forEach(function (x) { x.classList.remove("active"); });
        s.classList.add("active");
        if (nameEl) nameEl.textContent = s.dataset.name || "";
      });
    });

    /* estimate form on this page: pre-fill the product */
    var est = document.getElementById("estimate-form");
    if (est) est.setAttribute("data-product", p.name);

    /* sticky mobile enquiry bar */
    var sticky = document.getElementById("pdp-sticky");
    if (sticky) {
      sticky.innerHTML =
        '<a class="btn btn-wa" target="_blank" rel="noopener" href="' + productEnquiry(p) + '">' + WA_ICON + " " + esc(cget("product.detail.stickyWa", "WhatsApp")) + "</a>" +
        '<a class="btn btn-outline" href="#estimate">' + esc(cget("product.detail.stickyEstimate", "Get estimate")) + "</a>";
      document.body.classList.add("has-sticky");
    }

    /* "Other sofas from the same product name":
       1. pieces sharing a family name set in the admin, or, failing that,
          whose names start with the same word (Dundee, Dundee 2 Seater…)
       2. until a piece has such mates, its other configurations become
          picture tiles ("Dundee in other shapes and sizes"), each opening a
          WhatsApp enquiry for that configuration. */
    var famWrap = document.getElementById("family-grid");
    var famSection = document.getElementById("family-section");
    if (famWrap && famSection) {
      function famKey(x) {
        var f = String(x.family || "").trim().toLowerCase();
        return f || String(x.name || "").trim().split(/\s+/)[0].toLowerCase();
      }
      var key = famKey(p);
      var mates = key ? PRODUCTS.filter(function (x) { return x.slug !== p.slug && famKey(x) === key; }) : [];
      var famEyebrow = famSection.querySelector(".eyebrow");
      var famHead = famSection.querySelector("h2");
      var shapes = configs.filter(function (c, i) { return i > 0 && !/custom/i.test(c); });
      if (mates.length) {
        famWrap.innerHTML = mates.slice(0, 4).map(function (rp, i) { return cardHTML(rp, i % 4); }).join("");
        if (famEyebrow) famEyebrow.textContent = cget("product.family.eyebrow", "Same family");
        if (famHead) famHead.textContent = cget("product.family.title", "More from the") + " " + (String(p.family || "").trim() || p.name.split(/\s+/)[0]) + " " + cget("product.family.suffix", "family");
        famSection.hidden = false;
      } else if (shapes.length) {
        famWrap.innerHTML = shapes.slice(0, 4).map(function (c, i) {
          var img = p.images[(i + 1) % p.images.length] || p.images[0];
          return '<a class="cat-tile shape-tile" target="_blank" rel="noopener" data-reveal data-reveal-delay="' + (i % 4) + '" href="' +
            waLink("Hi Furniversal, I'm interested in the " + p.name + " in the " + c + " configuration. Please share the price and options.") + '">' +
            '<div class="cat-img"><img src="' + esc(imgURL(p, img)) + '" alt="' + esc(p.name + " " + c) + '" loading="lazy"></div>' +
            "<h3>" + esc(c) + ARROW + "</h3><span>" + esc(cget("product.family.shapesCta", "Enquire on WhatsApp")) + "</span></a>";
        }).join("");
        if (famEyebrow) famEyebrow.textContent = cget("product.family.shapesEyebrow", "Shapes & sizes");
        if (famHead) famHead.textContent = p.name + " " + cget("product.family.shapesTitle", "in other shapes and sizes");
        famSection.hidden = false;
      } else famSection.hidden = true;
    }

    /* recommended (same category first, then fill) */
    var relWrap = document.getElementById("related-grid");
    if (relWrap) {
      var related = PRODUCTS.filter(function (x) {
        return x.slug !== p.slug && prodCats(x).some(function (c) { return inCat(p, c); });
      });
      PRODUCTS.forEach(function (x) { if (related.length < 4 && x.slug !== p.slug && related.indexOf(x) === -1) related.push(x); });
      relWrap.innerHTML = related.slice(0, 4).map(function (rp, i) { return cardHTML(rp, i % 4); }).join("");
    }

    /* recently viewed */
    var recent = readRecent().filter(function (s) { return s !== p.slug; });
    pushRecent(p.slug);
    var recWrap = document.getElementById("recent-grid");
    var recSection = document.getElementById("recent-section");
    if (recWrap && recSection) {
      var rp = recent.map(function (s) { return PRODUCTS.find(function (x) { return x.slug === s; }); }).filter(Boolean).slice(0, 4);
      if (rp.length) { recWrap.innerHTML = rp.map(function (x, i) { return cardHTML(x, i % 4); }).join(""); recSection.hidden = false; }
      else recSection.hidden = true;
    }

    initFAQ();
    initReveal();
    initVideoAutoplay();
    document.dispatchEvent(new CustomEvent("fv:product", { detail: { product: p, root: root } }));
  }

  /* =========================================================
     7. FAQ accordion
     ========================================================= */
  // Long review text is clamped with a "Read more" toggle
  function initReviewClamp() {
    document.querySelectorAll(".review-card > p:not([data-clamp])").forEach(function (p) {
      p.setAttribute("data-clamp", "1");
      p.classList.add("clamp");
      if (p.scrollHeight <= p.clientHeight + 4) { p.classList.remove("clamp"); return; }
      var b = document.createElement("button");
      b.type = "button"; b.className = "read-more"; b.textContent = cget("home.reviews.more", "Read more");
      b.addEventListener("click", function () {
        var open = p.classList.toggle("clamp");
        b.textContent = open ? cget("home.reviews.more", "Read more") : cget("home.reviews.less", "Show less");
      });
      p.insertAdjacentElement("afterend", b);
    });
  }

  function initFAQ() {
    var items = document.querySelectorAll(".faq-item");
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector(".faq-q");
      var a = item.querySelector(".faq-a");
      if (!q || !a || q.dataset.bound) return;
      q.dataset.bound = "1";
      q.addEventListener("click", function () {
        var isOpen = item.classList.contains("open");
        items.forEach(function (other) {
          other.classList.remove("open");
          var oa = other.querySelector(".faq-a");
          if (oa) oa.style.maxHeight = null;
        });
        if (!isOpen) { item.classList.add("open"); a.style.maxHeight = a.scrollHeight + "px"; }
      });
    });
    // support.html#terms etc.: open the matching policy and scroll to it
    function openHash() {
      var id = (location.hash || "").slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target || !target.classList.contains("faq-item")) return;
      var q = target.querySelector(".faq-q");
      if (q && !target.classList.contains("open")) q.click();
      setTimeout(function () { target.scrollIntoView({ behavior: "smooth", block: "start" }); }, 60);
    }
    window.addEventListener("hashchange", openHash);
    setTimeout(openHash, 150);
  }

  /* =========================================================
     8. Forms -> WhatsApp (no backend needed)
     ========================================================= */
  function fieldVal(form, name) {
    var el = form.querySelector('[name="' + name + '"]') || form.querySelector('[name="contact[' + name + ']"]');
    if (!el) return "";
    if (el.type === "radio") {
      var c = form.querySelector('[name="' + name + '"]:checked') || form.querySelector('[name="contact[' + name + ']"]:checked');
      return c ? c.value : "";
    }
    if (el.type === "checkbox") return el.checked ? el.value : "";
    return (el.value || "").trim();
  }

  // Contact form: two ways to send.
  //   WhatsApp button  -> opens a pre-filled chat (no backend needed)
  //   Send enquiry     -> POSTs to api/contact.php, which emails the team and keeps the lead
  //                       in data/leads.json (admin -> Leads). On a host without PHP it opens
  //                       the visitor's email app with the same details instead.
  function initContactForm() {
    var form = document.getElementById("contact-form");
    if (!form || form.dataset.bound) return;
    form.dataset.bound = "1";
    var status = document.getElementById("cf-status");
    function fields() {
      return { name: fieldVal(form, "name"), phone: fieldVal(form, "phone"), interest: fieldVal(form, "interest"),
               message: fieldVal(form, "message") || fieldVal(form, "body"), company: fieldVal(form, "company") };
    }
    function show(msg, isError) {
      if (!status) return;
      status.textContent = msg || ""; status.hidden = !msg; status.classList.toggle("error", !!isError);
    }
    function summary(v, lead) {
      var lines = [lead];
      if (v.name) lines.push("Name: " + v.name);
      if (v.phone) lines.push("Phone: " + v.phone);
      if (v.interest) lines.push("Interested in: " + v.interest);
      if (v.message) lines.push("Message: " + v.message);
      return lines.join("\n");
    }
    var waBtn = form.querySelector('[data-send="whatsapp"]');
    if (waBtn) waBtn.addEventListener("click", function () {
      window.open(waLink(summary(fields(), "Hi Furniversal, I'd like to enquire.")), "_blank", "noopener");
    });
    form.addEventListener("submit", function (e) {
      if (form.dataset.native) return;                 // Shopify contact form posts natively
      e.preventDefault();
      var v = fields();
      if (!v.name) { show(cget("home.contact.needName", "Please add your name."), true); var n = form.querySelector('[name="name"]'); if (n) n.focus(); return; }
      var btn = form.querySelector('[data-send="submit"]');
      if (btn) btn.disabled = true;
      show(cget("home.contact.sending", "Sending…"));
      function fallback() {
        var to = cget("global.contact.email", "hello@furniversal.in");
        var subject = "Website enquiry from " + v.name + (v.interest ? " (" + v.interest + ")" : "");
        show(cget("home.contact.sendFallback", "Opening your email app with the details filled in. If nothing happens, use WhatsApp instead."));
        window.location.href = "mailto:" + to + "?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(summary(v, "New enquiry from the Furniversal website"));
      }
      var payload = { name: v.name, phone: v.phone, interest: v.interest, message: v.message, company: v.company, page: window.location.href };
      fetch("api/contact.php", { method: "POST", headers: { "Content-Type": "application/json" }, credentials: "same-origin", body: JSON.stringify(payload) })
        .then(function (r) {
          var ct = r.headers.get("content-type") || "";
          if (ct.indexOf("application/json") === -1) throw new Error("no-api");
          return r.json();
        })
        .then(function (j) {
          if (!j || !j.ok) throw new Error((j && j.error) || "failed");
          show(cget("home.contact.sentMsg", "Thank you! We've received your enquiry and will get back to you within a working day."));
          form.reset();
        })
        .catch(function (err) {
          if (String(err && err.message) === "no-api") fallback();
          else show(cget("home.contact.sendError", "We couldn't send that just now. Please try WhatsApp, or email us directly."), true);
        })
        .then(function () { if (btn) btn.disabled = false; });
    });
  }

  // "Design your sofa" / "Get your sofa estimate": chips + a few fields -> WhatsApp
  function initEstimateForm() {
    var form = document.getElementById("estimate-form");
    if (!form || form.dataset.bound) return;
    form.dataset.bound = "1";
    function message() {
      var product = form.getAttribute("data-product") || "";
      var lines = [product ? "Hi Furniversal, I'd like an estimate for the " + product + "." : "Hi Furniversal, I'd like a sofa estimate."];
      var pairs = [
        ["Looking for", fieldVal(form, "type")],
        ["Material", fieldVal(form, "material")],
        ["Colour preference", fieldVal(form, "colour")],
        ["Room size", fieldVal(form, "room")],
        ["Room photo", fieldVal(form, "photo") ? cget("home.estimate.photoLine", "I'll attach it in this chat") : ""],
        ["Budget", fieldVal(form, "budget")],
        ["Name", fieldVal(form, "name")],
        ["WhatsApp", fieldVal(form, "phone")]
      ];
      pairs.forEach(function (x) { if (x[1]) lines.push(x[0] + ": " + x[1]); });
      return lines.join("\n");
    }
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      window.open(waLink(message()), "_blank", "noopener");
    });
    var visit = form.querySelector("[data-estimate-visit]");
    if (visit) visit.addEventListener("click", function (e) {
      e.preventDefault();
      window.open(waLink(message() + "\n\nI'd like to book a showroom consultation."), "_blank", "noopener");
    });
  }

  // Showroom: "Book a visit" -> WhatsApp
  function initVisitForm() {
    var form = document.getElementById("visit-form");
    if (!form || form.dataset.bound) return;
    form.dataset.bound = "1";
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var lines = ["Hi Furniversal, I'd like to book a showroom visit."];
      var pairs = [["Name", fieldVal(form, "name")], ["WhatsApp", fieldVal(form, "phone")], ["Preferred date", fieldVal(form, "date")], ["Preferred time", fieldVal(form, "time")], ["Looking for", fieldVal(form, "interest")]];
      pairs.forEach(function (x) { if (x[1]) lines.push(x[0] + ": " + x[1]); });
      window.open(waLink(lines.join("\n")), "_blank", "noopener");
    });
  }

  /* =========================================================
     Data loading, live API with static fallback
     ========================================================= */
  function loadProducts() {
    // Shopify: products come from the store (fv-shopify.js maps them), or the bundled catalogue
    var data = window.FV_SHOPIFY && window.FV_SHOPIFY.catalogue ? window.FV_SHOPIFY.catalogue() : null;
    if (data && data.categories && data.categories.length) CAT_ORDER = data.categories;
    return Promise.resolve((data && data.products) || window.FURNIVERSAL_PRODUCTS || []);
  }

  /* =========================================================
     Boot
     ========================================================= */
  function initProductUI() {
    initHomeProducts();
    initHomeVideos();
    initShop();
    initProduct();
    document.dispatchEvent(new CustomEvent("fv:products"));
  }
  window.FV_INIT_PRODUCT_UI = function (data) {
    if (data && data.products) { PRODUCTS = data.products; if (data.categories && data.categories.length) CAT_ORDER = data.categories; }
    initProductUI();
  };

  document.addEventListener("DOMContentLoaded", function () {
    initHeader();
    initWidget();
    initReveal();

    var contentReady = window.FV_CONTENT_READY || Promise.resolve();
    contentReady.then(function () {
      initHeroSlider();
      initFAQ();
      initReviewClamp();
      initContactForm();
      initEstimateForm();
      initVisitForm();
      initReveal();
      initVideoAutoplay();
      var cta = document.getElementById("wapp-cta");
      if (cta) cta.href = waLink(cget("global.whatsapp.greeting", "Hi Furniversal, I would like a free design consultation."));
    });

    Promise.all([contentReady, loadProducts()]).then(function (res) {
      PRODUCTS = res[1];
      initProductUI();
    });
  });
})();
